export default __webpack_public_path__ + "static/media/bg2.dae2a71a.jpg";